import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import useDate from '../../hooks/app/useDate'

const TextFormatDateRange = ({ startDate, endDate, className, colorText }) => {
  if (!startDate && !endDate) {
    return (
      <Typography 
        variant='inherit'
        component={'p'}
        className={['text-muted-foreground opacity-50', className].join(' ')}
      >
        No date assigned
      </Typography>
    )
  }

  const { determinateStatus, formatDate } = useDate()
  const status = determinateStatus(startDate, endDate)
  const start = formatDate(startDate)
  const end = formatDate(endDate)

  return (
    <>
      <Tooltip arrow placement='top' title={<span className='capitalize'>{status}</span>}>
        <Typography
          variant='inherit'
          component={'p'}
          className={[
            'capitalize',
            status === 'active' ? 'font-bold' : '',
            status === 'active' ? colorText || 'text-secondary' : 'text-muted-foreground opacity-50',
            className
          ].join(' ')}
        >
          {start}{end ? ` - ${end}` : ''}
        </Typography>
      </Tooltip>
    </>
  )
}

export default TextFormatDateRange